<div class="payment-method-logo sports-only payment-method-{{ usedOption()?.paymentMethod }}"></div>
@let paymentMethodName = usedOption()?.paymentMethod?.toUpperCase();
<div class="payment-text">
    @if (paymentMethodName === 'INSTANTECHECKS') {
        <span>{{ 'PARTY.CASHIER.web.deposit.instantechecks.name.us' | translate }}</span>
    }
    @if (paymentMethodName === 'INTERCHECKS_ACH') {
        <span class="payment-name">{{ 'PARTY.CASHIER.web.deposit.achInterchecks.name' | translate }}</span>
    }
    @if (paymentMethodName === 'BORGATAPREPAIDCARD') {
        <span>{{ 'PARTY.CASHIER.web.deposit.ewallet.play.name.us' | translate }}</span>
    }
    @if (paymentMethodName === 'PLAYMGMPREPAIDCARD') {
        <span>{{ 'PARTY.CASHIER.web.deposit.ewallet.betmgmplay.name.us' | translate }}</span>
    }
    @if (paymentMethodName === 'MLIFE') {
        <span>{{ 'PARTY.CASHIER.web.deposit.mgmrewards.name' | translate }}</span>
    }
    @if (!(paymentMethodName === 'APPLEPAYDIRECT' || prepaidCardsAndEchecks.includes(paymentMethodName ?? ''))) {
        <span>{{ usedOption()?.paymentText }}</span>
    }
    @if (paymentMethodName === 'APPLEPAYDIRECT') {
        <span>
            {{ 'PARTY.CASHIER.web.deposit.applepaydirect.name' | translate }}
        </span>
    }
    @if (!['APPLEPAYDIRECT'].includes(paymentMethodName ?? '')) {
        <span> {{ usedOption()?.instrumentNumber }}</span>
    }
</div>
@if (usedOption()?.sportsOnly && !usedOption()?.bankAccountsOnly) {
    <div>
        <div class="sports-only-ribbon">
            <div class="ribbon-text">{{ 'PARTY.CASHIER.web.deposit.sports.only.ribbon.text' | translate }}</div>
        </div>
    </div>
}
@if (usedOption()?.bankAccountsOnly && !usedOption()?.sportsOnly) {
    <div>
        @if (isUSLabel()) {
            <div class="sports-only-ribbon wp-66">
                <div class="ribbon-text">{{ 'PARTY.CASHIER.web.deposit.bank.accounts.only.ribbon.text' | translate }}</div>
            </div>
        }
    </div>
}
